<div class="storeNameOuter" *ngIf="superAdminLoggedIn">
  <span class="storeName">
    <i class="fa fa-dot-circle-o pulsate"></i>
    {{storeName.split('.')[0]}}
  </span>
</div>
<div class="content-blk">
  <div class="list-steps">
    <div [ngClass]="{'step-circle':true,'active':listPanels.options}">
      <div class="num">1</div>
      <div class="title-step">Select Product </div>
    </div>
    <div [ngClass]="{'step-circle':true,'active':listPanels.customizeProduct}">
      <div class="num">2</div>
      <div class="title-step">Customize Product</div>
    </div>
    <div [ngClass]="{'step-circle':true,'active':listPanels.sizingLabel}">
      <div class="num">3</div>
      <div class="title-step">Finishing Pricing</div>
    </div>
    <div [ngClass]="{'step-circle':true,'active':listPanels.pricing}">
      <div class="num">4</div>
      <div class="title-step">Pricing</div>
    </div>
    <div *ngIf="!IsBulkUploadType" [ngClass]="{'step-circle':true,'active':listPanels.selectStore}"
         [hidden]="!listPanelHeaders.selectStore">
      <div class="num">5</div>
      <div class="title-step">Publish To The Store</div>
    </div>
    <div *ngIf="IsBulkUploadType" [ngClass]="{'step-circle':true,'active':listPanels.selectStore}"
         [hidden]="!listPanelHeaders.selectStore">
      <div class="num">5</div>
      <div class="title-step">Payment</div>
    </div>
    <div *ngIf="IsBulkUploadType" [ngClass]="{'step-circle':true,'active':listPanels.selectStore}"
         [hidden]="!listPanelHeaders.selectStore">
      <div class="num">6</div>
      <div class="title-step">Publish To The Store</div>
    </div>
  </div>

  <div class="window">
    <div [ngClass]="{'panel-step':true,'active':listPanels.options}">
      <app-master-product-listing (ProductData)="fn_CustomizeProduct($event)"></app-master-product-listing>
    </div>
    <div [ngClass]="{'panel-step':true,'active':listPanels.customizeProduct}">
      <!-- Editor Selection: Inksoft vs Design Huddle -->
      <div *ngIf="showCustomPage && !editorSelected" class="editor-selection-panel">
        <h3 class="text-center">Choose Design Editor</h3>
        <div class="row" style="margin-top: 30px;">
          <!-- INKSOFT DISABLED (2026-09): legacy InkSoft editor option removed so store-admins can only
               create with Design Huddle. Kept commented (not deleted) for auditability during InkSoft decommission.
          <div class="col-md-6 text-center">
            <button class="btn btn-lg btn-primary editor-choice-btn" (click)="selectEditor('inksoft')" style="width: 80%; padding: 20px;">
              <i class="fa fa-paint-brush"></i><br>
              Create with Inksoft<br>
              <small class="text-muted">(Legacy Editor)</small>
            </button>
          </div>
          -->
          <div class="col-md-12 text-center">
            <button class="btn btn-lg btn-success editor-choice-btn" (click)="selectEditor('designhuddle')" style="width: 80%; padding: 20px;">
              <i class="fa fa-magic"></i><br>
              Create with Design Huddle<br>
              <small class="text-muted">(New Editor)</small>
            </button>
          </div>
        </div>
      </div>

      <!-- Inksoft Editor — INKSOFT DISABLED (2026-09): hard-guarded off. The picker no longer offers 'inksoft'
           (selectEditor('inksoft') was the only trigger), so selectedEditor can never be 'inksoft'; *ngIf="false"
           guarantees the InkSoft designer never mounts and fn_SaveDesign (POST /Product/SaveCustomizedProduct) never fires. -->
      <app-inksofteditor [data]="selectProduct" [addProductPopup]="true" (NewDesignData)="fn_SaveDesign($event)"
                         *ngIf="false"></app-inksofteditor>

      <!-- Design Huddle Editor -->
      <app-design-huddle-product-creator
        *ngIf="showCustomPage && editorSelected && selectedEditor === 'designhuddle'"
        [productId]="selectProduct?.productId"
        [styleId]="selectProduct?.styleId"
        [userId]="ApplicationUserId"
        [createdBy]="superAdminLoggedIn ? superadminUserId : ApplicationUserId"
        [productName]="selectProduct?.name || 'New Design'"
        (projectCreated)="fn_SaveDesignHuddleProject($event)"
        (cancelled)="editorSelected = false">
      </app-design-huddle-product-creator>
    </div>
    <div *ngIf="SizingLabelData.EnableSizingLabel" [ngClass]="{'panel-step':true,'active':listPanels.sizingLabel}">
      <div class="size-level-section" *ngIf="!selectProduct.sizingLabelExist">
        Do you want customized sizing label?
        <p class="sizing-option">
          <input name="showSizing" (click)="fn_getMySavedDesign()" [(ngModel)]="SizingLabelData.AddSizeLevel"
                 type="radio" [value]="true" [checked]="SizingLabelData.AddSizeLevel" /> Yes
          <input name="showSizing" [(ngModel)]="SizingLabelData.AddSizeLevel" type="radio" [value]="false"
                 [checked]="!SizingLabelData.AddSizeLevel" /> No
        </p>
      </div>
      <div class="size-level-section" *ngIf="selectProduct.sizingLabelExist">
        Do you want to update the sizing label?
        <p class="sizing-option">
          <input name="updateSizing" (click)="fn_getMySavedDesign()" [(ngModel)]="SizingLabelData.UpdateSizeLevel"
                 type="radio" [value]="true" [checked]="SizingLabelData.UpdateSizeLevel" /> Yes
          <input name="updateSizing" [(ngModel)]="SizingLabelData.UpdateSizeLevel" type="radio" [value]="false"
                 [checked]="!SizingLabelData.UpdateSizeLevel" /> No
        </p>
      </div>

      <div class="exist-SL" *ngIf="selectProduct.sizingLabelExist && !SizingLabelData.UpdateSizeLevel">
        <img [src]="existingSizingLabelImage" alt="Existed sizing label">
      </div>

      <div class="row size-label-div" *ngIf="SizingLabelData.AddSizeLevel || SizingLabelData.UpdateSizeLevel">
        <div class="col-md-6">
          <div class="divSizeLevel">
            <table class="sizeLevelTbl" align="center">
              <tbody>
                <tr>
                  <td colspan="2" class="logo">
                    <div id="divCanvas">
                      <app-drag-canvas></app-drag-canvas>
                    </div>
                  </td>
                </tr>
                <tr class="tr-fnt-stllst">
                  <td colspan="2" class="size">
                    <div class="dropdown" *ngIf="selectProduct.sizes && selectProduct.sizes.length">
                      <span class='{{SizingLabelData.FontStyle}}'>{{selectProduct.sizes[0].LongName}}</span>

                      <button type="button"  id="dropdownMenuButton" class="btn-font-option" data-toggle="dropdown" class="dropdown-toggle">
                      </button>
                      <ul class="dropdown-menu " >
                        <a class="dropdown-item"  (click)="SizingLabelData.FontStyle = 'ArialBlack'" style="font-family: Arial-Black !important" >Style 1</a>
                        <a class="dropdown-item"  (click)="SizingLabelData.FontStyle = 'TimesBold'" style="font-family: Times-Bold !important">Style 2</a>
                        <a  class="dropdown-item" (click)="SizingLabelData.FontStyle = 'ScriptMTBold'" style="font-family: Script-MT-Bold !important" >Style 3</a>
                        </ul>
                      </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="middle-section">
                    <div class="madein-outer">
                      <div class="madein">
                        <div>MADE IN</div>
                        <div> {{SizingLabelData.MadeIn}}</div>
                      </div>
                    </div>
                    <div class="composition-outer">
                      <div class="composition">
                        <ng-container *ngFor="let composition of SizingLabelData.Composition">
                          <p>
                            {{composition}}
                          </p>
                        </ng-container>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="rnNumber">
                    <span>RN# {{SizingLabelData.RN}}</span>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="laundryImg">
                    <img src="/assets/img/Laundry.PNG">
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="tagline">
                    <p class="tagline1">
                      <input type="text" [(ngModel)]="SizingLabelData.Tagline1" placeholder="Tagline" />
                      <!--<i class="fa fa-caret-right icon-red" aria-hidden="true"></i>-->
                    </p>
                    <p class="tagline2">
                      <input type="text" [(ngModel)]="SizingLabelData.Tagline2" placeholder="Sub Tagline" />
                      <!--<i class="fa fa-caret-right icon-red" aria-hidden="true"></i>-->
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <br />
          </div>
        </div>





        <div id="size-labelList" class="col-md-6" infiniteScroll infinite-scroll-parent='true'
             infinite-scroll-container="'#size-labelList'" [infiniteScrollDistance]="scrollDistance"
             [infiniteScrollThrottle]="throttle" (scrolled)="fn_getMySavedDesign()"
             [infiniteScrollDisabled]="isSavedSizeLabelDisplayed">

          <p>
            Choose from previous size labels
          </p>
          <div *ngIf="mySavedDesignList.length<=0" class="no-size-level-images text-danger">
            <i class="fa fa-picture-o"></i>
            <br />
            <small>*You have not created any size lebel yet.</small>
          </div>
          <div class="existing-size-level-images" *ngIf="mySavedDesignList.length!=0">
            <div *ngFor="let item of mySavedDesignList" class="previous-size-label">
              <img [src]="item.SizingLableImage" (click)="fn_SetMySaveDesignData(item.DesignId)" width="150" />
            </div>
          </div>

          <br />
          <br />
        </div>
      </div>


      <div class="btn-next">
        <button class="pblsh-mat-btn btn-success" mat-button (click)="nextPanel('pricing')">
          Next
        </button>
      </div>


    </div>
    <div [ngClass]="{'panel-step':true,'active':listPanels.pricing,'displayPricing':listPanels.pricing}">
      <div class="row" style="margin-bottom:5px">
        <div class="col-md-9"></div>
        <div class="col-md-2 dv-prft-fld">
          <mat-form-field *ngIf="!shopifyProduct" class="example-full-width">
            <input *ngIf="!IsBulkUploadType" matInput placeholder="$ Profit" #profitPriceText type="number"
                   (change)="updatePricing()" min="0" [(ngModel)]="profitPrice">
            <input *ngIf="IsBulkUploadType" matInput placeholder="$ Profit" #profitPriceText type="number"
                   (change)="updateBulkPricing()" min="0" [(ngModel)]="profitPrice">
          </mat-form-field>
          <mat-form-field *ngIf="shopifyProduct && shopifyProfit" class="example-full-width">
            <input matInput placeholder="$ Profit" #profitPriceText type="number"
                   (change)="updatePricingShopify()" min="0" [(ngModel)]="profitPrice" value="{{ shopifyProfit }}">
          </mat-form-field>
          <mat-form-field *ngIf="shopifyProduct && !shopifyProfit" class="example-full-width">
            <input matInput placeholder="$ Profit" #profitPriceText type="number"
                   (change)="updatePricingShopify()" min="0" [(ngModel)]="profitPrice">
          </mat-form-field>
        </div>

        <div *ngIf="shopifyProduct && !superAdminLoggedIn" class="col-md-1">
          <button class="pblsh-mat-btn btn-success" mat-raised-button (click)="saveShopifyData()">
            Save
          </button>
        </div>
        <div *ngIf="shopifyProduct && !isEditCase && superAdminLoggedIn" class="col-md-1">
          <button class="pblsh-mat-btn btn-success" mat-raised-button (click)="selectStorePanel()">
            Next
          </button>
        </div>
        <div *ngIf="shopifyProduct && isEditCase && superAdminLoggedIn" class="col-md-1">
          <button class="pblsh-mat-btn btn-success" mat-raised-button (click)="saveShopifyData()">
            Save
          </button>
        </div>
        <div *ngIf="!shopifyProduct && isEditCase && !IsBulkUploadOrder" class="col-md-1">
          <button class="pblsh-mat-btn btn-success" mat-button (click)="saveInksoftData()">
            Save
          </button>
        </div>
        <div *ngIf="!shopifyProduct && !isEditCase && !IsBulkUploadOrder" class="col-md-1">
          <button class="pblsh-mat-btn btn-success"  mat-button (click)="selectStorePanel()">
            Next
          </button>
        </div>
        <!-- <div *ngIf="!shopifyProduct && !IsBulkUploadOrder && (IsEmbroideryType && !isEditCase)" class="col-md-1">
          <button class="pblsh-mat-btn" mat-raised-button (click)="gotoPayment()">
            Next
          </button>
        </div> -->
        <div *ngIf="IsBulkUploadType && IsBulkUploadOrder" class="col-md-1">
          <button class="pblsh-mat-btn btn-success" mat-button  (click)="goto()">
            Pay Now
          </button>
        </div>
      </div>
      <br />
      <div class="alert alert-danger" *ngIf="!IsPublished  && !isEditCase" role="alert" style="padding:5px 7px">
        <i class="fa fa-warning"></i>
        <small>
          Please save style and profit of the product to be published in the store.
        </small>
      </div>
      <small *ngIf="shopifyProduct" style="font-size:12px" class="text-muted">
        *Retail Price includes <strong>{{shopifyProfit|currency:'USD':'symbol':'1.0-2'}}</strong> profit.
      </small>
      <small *ngIf="!shopifyProduct" style="font-size:12px" class="text-muted">
        *Retail Price includes <strong>{{profitPrice |currency:'USD':'symbol':'1.0-2'}}</strong> profit.
      </small>
      <small *ngIf="finishingCost && finishingCost > 0" style="font-size:12px" class="text-muted">
        *Retail Price includes <strong>{{ finishingCost |currency:'USD':'symbol':'1.0-2'}}</strong> finishing price.
      </small>
      <small *ngIf="(additionalPrintCost && additionalPrintCost>0) && !IsEmbroideryType" style="font-size:12px"
             class="text-muted">
        *Price includes <strong>{{ additionalPrintCost |currency:'USD':'symbol':'1.0-2'}}</strong> additional print cost
        per side (cost will included for more than one side) .
      </small>
      <div>
        <small *ngIf="EmbroideryCost && EmbroideryCost > 0 && IsEmbroideryType" style="font-size:12px"
               class="text-muted">
          *Retail Price includes <strong>{{ EmbroideryCost |currency:'USD':'symbol':'1.0-2'}}</strong> embroidery cost
          per side.
        </small>
        <div>
          <small *ngIf="EmbroiderySetUpCost && EmbroiderySetUpCost > 0 &&IsEmbroideryType" style="font-size:12px"
                 class="text-muted">
            One time <strong>{{ EmbroiderySetUpCost |currency:'USD':'symbol':'1.0-2'}}</strong> per side will be charged
            on first order as a Embroidery setup fees. Order will not be fulfilled incase of failed payments for
            Embroidery setup cost.
          </small><br />
          <small *ngIf="isEditCase && IsEmbroideryType" class="text-info">
            You can only update varients, size label and profit for embroidery type.
          </small>
        </div>
        <br />

        <!-- Tags and Labels Section (hidden, kept for future use) -->
        <div class="row tags-labels-section" *ngIf="false">
          <div class="col-md-6">
            <div class="form-group tag-group tags-card">
              <label class="lbl-pbls section-label"><i class="fa fa-tags"></i> Product Tags</label>
              <div class="row dv-lbl-hdng">
                <div class="col-md-8">
                  <p class="labels">Tag Name</p>
                </div>
              </div>
              <div class="row dv-prdc-lbl" *ngFor="let item of productTags; index as j">
                <div class="col-md-7">
                  <input type="text" class="form-control" [(ngModel)]="item.tagtext" placeholder="Enter tag">
                </div>
                <div class="col-md-2 dv-icns">
                  <i *ngIf="productTags.length > 1" class="fa fa-minus" title="Remove" (click)="fn_RemoveTag(j)"></i>
                  <i *ngIf="productTags.length - 1 == j && productTags.length < 15" class="fa fa-plus" title="Add" (click)="fn_AddTag()"></i>
                </div>
                <div *ngIf="item.tagtext" class="col-md-3">
                  <span class="tag-preview">{{item.tagtext}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group labels-card">
              <label class="lbl-pbls section-label"><i class="fa fa-bookmark"></i> Product Labels</label>
              <div class="row dv-lbl-hdng">
                <div class="col-md-4">
                  <p class="labels">Label Name</p>
                </div>
                <div class="col-md-3">
                  <p class="labels">Background</p>
                </div>
                <div class="col-md-3">
                  <p class="labels">Text Color</p>
                </div>
              </div>
              <div class="row dv-prdc-lbl" *ngFor="let item of productLabels; index as i">
                <div class="col-md-4">
                  <input type="text" class="form-control" [(ngModel)]="item.text" placeholder="Enter label">
                </div>
                <div class="col-md-3">
                  <div class="input-group color-input-group">
                    <input type="text" class="form-control" [(ngModel)]="item.backgroundColor">
                    <span class="input-group-btn">
                      <button class="btn btn-default color-picker" type="button">
                        <input type="color" class="color-input" [(ngModel)]="item.backgroundColor">
                      </button>
                    </span>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="input-group color-input-group">
                    <input type="text" class="form-control" [(ngModel)]="item.textColor">
                    <span class="input-group-btn">
                      <button class="btn btn-default color-picker" type="button">
                        <input type="color" class="color-input" [(ngModel)]="item.textColor">
                      </button>
                    </span>
                  </div>
                </div>
                <div class="col-md-1 dv-icns">
                  <i *ngIf="productLabels.length > 1" class="fa fa-minus" title="Remove" (click)="fn_RemoveLabel(i)"></i>
                  <i *ngIf="productLabels.length - 1 == i && productLabels.length < 3" class="fa fa-plus" title="Add" (click)="fn_AddLabel()"></i>
                </div>
                <div *ngIf="item.text" class="col-md-12 label-preview-row">
                  <span class="badge label-preview" [ngStyle]="{'background-color': item.backgroundColor, 'color': item.textColor}">
                    {{item.text}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="IsBulkUploadType" style="margin-left:0%" class="row">
          <mat-checkbox [checked]="IsBulkUploadOrder" (change)="fn_displayColumn($event)"
                        [(ngModel)]="IsBulkUploadOrder"></mat-checkbox>
          <div class="col-md-2">
            <span>Bulk Order </span>
          </div>
          <br />
        </div>
        <div style="height: 55vh;overflow-y: scroll;border: 1px solid #e1e2e2;margin-bottom: 15px;">
          <table mat-table [dataSource]="dataPricingSize" class="mat-elevation-z8 tbl-stl-lst" style="width: 100%"
                 multiTemplateDataRows>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef> #</th>
              <td mat-cell *matCellDef="let element; let i = dataIndex" [attr.rowspan]="getRowSpan('select',i)"
                  [style.display]="getRowSpan('select', i) ? '' : 'none'">
                <mat-checkbox [checked]="element.select" (click)="$event.stopPropagation()" [(ngModel)]="element.select"
                              (change)="SelectProductStyle($event, element.styleId, element.uniqueStyleId, null)"></mat-checkbox>
              </td>
            </ng-container>
            <!-- Color Column -->
            <ng-container matColumnDef="color">
              <th mat-header-cell *matHeaderCellDef> Color </th>
              <td mat-cell *matCellDef="let element; let i = dataIndex" [attr.rowspan]="getRowSpan('select',i)"
                  [style.display]="getRowSpan('select', i) ? '' : 'none'">
                <div>
                  <a href="javascript:void(0);" (click)="fn_ShowVariantImage(element.imageUrl, element.colorName)">
                    <img [alt]="element.colorName" [src]="element.imageUrl" width="80" />
                  </a>
                </div>
                <!-- INKSOFT DISABLED (2026-09): per-variant "Change design" opened the legacy InkSoft editor
                     (designVariantDialog -> app-inksofteditor -> fn_SaveVariantDesign). Hidden so no new InkSoft
                     variant designs are created. Design Huddle handles per-variant designs in its own creator. -->
                <div *ngIf="false">
                  <a href="javascript:void(0);" (click)="fn_DesignVariant(element)"
                     style="padding: 5px 10px; text-decoration: none;">
                    <i class="fa fa-edit"></i>
                    Change design
                  </a>
                </div>

              </td>
            </ng-container>
            <!-- Color Name Column -->
            <ng-container matColumnDef="colorName">
              <th mat-header-cell *matHeaderCellDef> Color Name</th>
              <td mat-cell *matCellDef="let element;let i = dataIndex" [attr.rowspan]="getRowSpan('colorName',i)"
                  [style.display]="getRowSpan('colorName', i) ? '' : 'none'" style="border-right: 1px solid #e1e2e2">
                {{element.colorName}}
              </td>
            </ng-container>
            <!-- Position Column -->
            <ng-container matColumnDef="sizeName">
              <th mat-header-cell *matHeaderCellDef> Name Size</th>
              <td mat-cell *matCellDef="let element"> {{element.sizeName}} </td>
            </ng-container>
            <!-- Name Column -->
            <ng-container matColumnDef="price">
              <th mat-header-cell *matHeaderCellDef>
                <abbr title="Cost of Product inlcludes only one print location">
                  Product
                  Cost
                </abbr>
              </th>
              <td mat-cell *matCellDef="let element"> {{element.price | currency:'USD':'symbol':'1.0-2'}} </td>
            </ng-container>
            <!-- Weight Column -->
            <!-- Symbol Column -->
            <ng-container matColumnDef="retailPrice">
              <th mat-header-cell *matHeaderCellDef> Retail Price</th>
              <td mat-cell *matCellDef="let element"> {{element.retailPrice| currency:'USD':'symbol':'1.0-2'}} </td>
            </ng-container>

            <ng-container matColumnDef="showQuantityEnabled">
              <th mat-header-cell *matHeaderCellDef> Quantity</th>
              <td mat-cell *matCellDef="let element">
                <input #qty [disabled]="!element.select" (change)="fn_calculateBulkPrice(element,qty.value)"
                       value="{{element.bulkPerSizeQuantity}}" step="1" oninput="validity.valid||(value='');" class="qntycss"
                       type="number" min="0" />

              </td>
            </ng-container>
            <ng-container matColumnDef="totalbulkPrice">
              <th mat-header-cell *matHeaderCellDef> Bulk Price</th>
              <td mat-cell *matCellDef="let element">{{element.totalbulkPrice | currency:'USD':'symbol':'1.0-2'}}</td>
            </ng-container>
          </table>
        </div>

      </div>
    </div>
    <div [ngClass]="{'panel-step':true,'active':listPanels.payment}">

      <div class="sctpay" *ngIf="IsBulkUploadType">
        <div class="col-md-12">
          <a class="pull-right text-danger" (click)="GoBack()" href="javascript:void(0)">
            <i class="fa fa-arrow-left" aria-hidden="true"></i>
            Back
          </a>
        </div>
        <!--<div class="pull-right">
          <button class="pblsh-mat-btn" mat-raised-button (click)="GoBack()">
            Back
          </button>
        </div>-->
        <h3 class="text-muted text-center">
          Make a Payment
        </h3>
        <br />

        <table align="center" class="payment-table">
          <tr>
            <td>
              <h6 class="text-info">Bulk Price</h6>
            </td>
            <td class="pull-right">
              <strong>{{totalCost| currency:'USD':'symbol':'1.0-2'}}</strong>
            </td>
          </tr>
          <tr *ngIf="IsEmbroideryType">
            <td>
              <h6 class="text-info">Embroidery Setup Cost</h6>
            </td>
            <td class="pull-right">
              <strong>
                <span class="text-danger">(+)&nbsp;</span>{{EmbroiderySetUpCost|currency:'USD':'symbol':'1.0-2'}}
              </strong>
            </td>
          </tr>


          <tr>
            <td>
              <h6 class="text-info">Bulk Disount</h6>
            </td>
            <td class="pull-right">
              <strong>
                <span class="text-danger">(-)&nbsp;</span>{{discountedPrice|currency:'USD':'symbol':'1.0-2'}}
              </strong>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <hr />
            </td>
          </tr>
          <tr>
            <td>
              <h6 class="text-info font-25">Total Amount</h6><br />
            </td>
            <td class="pull-right">
              <strong class="font-25">{{totalCosttoCharge| currency:'USD':'symbol':'1.0-2'}}</strong>
            </td>
          </tr>
        </table>

        <small class="text-info">
          Proceed to pay the amount of <strong class="font-25">
            {{totalCosttoCharge|currency:'USD':'symbol':'1.0-2'}}
          </strong> for bulk order.
        </small>
        <br /><br />
      </div>
      <div *ngIf="!IsBulkUploadType && this.IsEmbroideryType">
        <h3 class="text-muted text-center">
          Make a Payment
        </h3><br /><br />
        <h6 class="text-info text-center">
          Proceed to pay one time embroidery setup amount of <strong class="font-25">{{EmbroiderySetUpCost| currency:'USD':'symbol':'1.0-2'}}</strong>
        </h6>
      </div>
      <div class="text-center w-50 mx-auto">
        <ngx-paypal [config]="payPalConfig"></ngx-paypal>
      </div>

    </div>
    <div [ngClass]="{'panel-step':true,'displayStore':listPanels.selectStore,'active':listPanels.selectStore}">
      <div class="str-dlg-mdl" style="width: 100%;max-width: 100%;" *ngIf="!superAdminLoggedIn">
        <div class="store-set-blk">
          <div class="store-set-ui">
            <form [formGroup]="storeForm" (ngSubmit)="fn_publish()">
              <mat-radio-group>
                <ul class="storelist-bx popup-checkbx-list">
                  <li *ngFor="let store of storeList">
                    <div class="mt-chk-blk btn-strlst-slct">
                      <mat-radio-button [value]="store.StoreId" class="mat-radio-content btn-strlst-slct"
                        [ngStyle]="{'background-image': getStoreBannerImage(store)}" #publishCheckbox
                        (change)="fn_SelectPublishProducts($event, store.StoreId,storeForm)">
                        <app-store></app-store>
                        <span class="optwrp">{{store.StoreName}}</span>

                      </mat-radio-button>
                    </div>
                  </li>
                  <li>
                    <div class="mt-chk-blk btn-strlst-slct">
                      <mat-radio-button [value]="0" class="mat-radio-content" (change)="addStore()">
                        <app-store></app-store>
                        <span class="optwrp">Create Store</span>

                      </mat-radio-button>
                    </div>
                  </li>
                  <li>
                    <div class="mt-chk-blk" style="text-align: center;">
                      <button mat-button class="pblsh-mat-btn btn-success" [disabled]="selectedStore === 0">
                        Publish The Product
                      </button>
                    </div>
                  </li>
                </ul>
              </mat-radio-group>

            </form>
          </div>
        </div>
      </div>

      <div *ngIf="superAdminLoggedIn">


        <!-- START -->
        <div class="row frm-bdy">
          <div class="col-sm-4">
            <img src="{{ masterProductImgBaseURL + PngRelativeUrlWithProduct }}" alt="ProductImage">
            <!-- <app-thumbnail [source]="masterProductImgBaseURL + PngRelativeUrlWithProduct" size="large" alt="image">
            </app-thumbnail> -->
          </div>
          <div class="col-sm-8">
            <div class="form-group">
              <label for="title" class="lbl-pbls">Title</label>
              <input type="text" class="form-control" id="title" [(ngModel)]="detailText.text">
            </div>
            <div class="form-group">
              <label for="description" class="lbl-pbls">Description</label>
              <textarea [(ngModel)]="detailText.description" rows="5" class=" desc form-control" id="description"></textarea>
            </div>

            <div class="form-group tag-group">
              <label for="description" class="lbl-pbls">Add Product Tag</label>
              <div class="row dv-lbl-hdng">
                <div class="col-md-3">
                  <p class="labels">Tag Name</p>
                </div>
              </div>
              <div class="row dv-prdc-lbl" *ngFor="let item of productTags; index as j">
                <div class="col-md-3">
                  <input style="margin-top:2px" type="text" class="form-control" id="tagtext" [(ngModel)]="item.tagtext" [readonly]="item.isDefault" [disabled]="item.isDefault" [placeholder]="item.isDefault ? 'Decoration Type (Auto)' : 'Tag text'">
                </div>
                <div class="col-md-1 dv-icns">
                  &nbsp;&nbsp;
                  <i *ngIf="productTags.length > 1 && !item.isDefault" class="fa fa-minus" (click)="fn_RemoveTag(j)"></i>
                  &nbsp; <i style="margin-left: 7px" *ngIf="productTags.length - 1 == j && productTags.length < 15"
                            class="fa fa-plus" (click)="fn_AddTag()"></i>
                </div>
                <div *ngIf="item.tagtext" class="col-md-3">
                  <div class="dv-lbl-prvew" [class.default-tag]="item.isDefault">
                    {{item.tagtext}}
                    <span *ngIf="item.isDefault" style="margin-left: 5px; font-size: 10px;">(Default)</span>
                  </div>
                </div>
              </div>


            </div>
            <div class="form-group">
              <label for="description" class="lbl-pbls">Add Product Label</label>
              <div class="row dv-lbl-hdng">
                <div class="col-md-3">
                  <p class="labels"> Label Name</p>
                </div>
                <div class="col-md-3">
                  <p class="labels"> Background Color</p>
                </div>
                <div class="col-md-3">
                  <p class="labels"> Text Color</p>
                </div>
              </div>


              <div class="row dv-prdc-lbl" *ngFor="let item of productLabels; index as i">
                <div class="col-md-3">
                  <input type="text" class="form-control " id="text" [(ngModel)]="item.text">
                </div>
                <div class="col-md-3">
                  <div class="input-group">
                    <input type="text" class="form-control" [(ngModel)]="item.backgroundColor"
                           (input)="onColorInputChange($event, item, 'background')">
                    <span class="input-group-btn" style="position: relative;">
                      <button class="btn btn-default color-picker" type="button" style="padding: 0;">

                        <input type="color" class="color-input" [(ngModel)]="item.backgroundColor"
                               (input)="onColorInputChange($event, item, 'background')">
                      </button>
                    </span>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="input-group">
                    <input type="text" class="form-control" [(ngModel)]="item.textColor"
                           (input)="onColorInputChange($event, item, 'text')">
                    <span class="input-group-btn" style="position: relative;">
                      <button class="btn btn-default color-picker" type="button" style="padding: 0;">

                        <input type="color" class="color-input" [(ngModel)]="item.textColor"
                               (input)="onColorInputChange($event, item, 'text')">
                      </button>
                    </span>
                  </div>
                </div>

                <div class="col-md-1 dv-icns">
                  &nbsp;&nbsp;
                  <i *ngIf="productLabels.length > 1" class="fa fa-minus" (click)="fn_RemoveLabel(i)"></i>
                  &nbsp; <i style="margin-left: 7px;" *ngIf="productLabels.length - 1 == i && productLabels.length < 3"
                            class="fa fa-plus" (click)="fn_AddLabel()"></i>
                </div>
                <div *ngIf="item.text" class="col-md-3">
                  <div class="badge dv-lbl-prvew"
                       [ngStyle]="{'background-color': item.backgroundColor, 'color': item.textColor}">
                    {{item.text}}
                  </div>
                </div>
              </div>

              <!-- END -->
              <br>
              <button class="mat-btn" mat-raised-button (click)="fn_AddProductToShopify()">
                Publish the Product to Shopify
              </button>
            </div>
          </div>

        </div>
      </div>


      <ng-template #imageDialog let-data>
        <button mat-icon-button class="close-button" mat-dialog-close="false">
          <mat-icon class="close-icon" color="warn">close</mat-icon>
        </button>
        <h2 matDialogTitle>{{ data.colorName }}</h2>
        <mat-dialog-content>
          <img class="img-upload-thumb" [src]="data.url" style="max-width: 100%; display: block; margin: auto;" />
        </mat-dialog-content>
      </ng-template>

      <ng-template #designVariantDialog let-data>
        <div class="designVariantDialog">
          <button mat-icon-button class="close-button" mat-dialog-close="false">
            <mat-icon class="close-icon" color="warn">close</mat-icon>
          </button>
          <h2 matDialogTitle>Change design for color - {{ data.colorName }}</h2>
          <mat-dialog-content>
            <div class="row">
<!-- INKSOFT DISABLED (2026-09): hard-guarded off (belt-and-suspenders with the hidden "Change design" trigger)
                   so the InkSoft variant designer can never mount and fn_SaveVariantDesign never fires. -->
              <app-inksofteditor [data]="data.selectProduct" [addProductPopup]="true"
                                 (NewDesignData)="fn_SaveVariantDesign($event)" *ngIf="false" style="width: 1100px;"></app-inksofteditor>
            </div>
          </mat-dialog-content>
        </div>
      </ng-template>
    </div>
  </div>
</div>
